import { Incident } from '@/core/models/incident';
import { POST } from '@/lib/api/Methods';
import { TCreatePoliceEncounter } from './incident.types';

export const createPoliceEncounter = (data: TCreatePoliceEncounter) =>
   POST<TCreatePoliceEncounter, Incident>('/incidents/police-encounter', data);
